// import React, { useEffect, useState } from "react";

// import "./popup.css";
// import Modal from "../../../../components/modal";
// import ApiService from "../../../../services/api";

// interface PatientModalProps {
//   open: boolean;
//   setOpen: (open: boolean) => void;
//   clinicProducts: Product[];
//   clinicId: number;
//   patient?: Patient | null;
// }

// interface Product {
//   product_id: number;
//   product_name?: string;
//   margin: number;
//   price: number;
// }

// interface PatientProduct {
//   patient_product_price_id: number;
//   product_id: number;
//   clinic_id: number;
//   margin_amount: number;
//   is_active: boolean;
// }

// interface Patient {
//   user_id: number;
//   first_name: string;
//   last_name: string;
//   email: string;
//   phone_number?: string;
//   dob: string;
//   status: "pending" | "approved" | "rejected";
//   is_active: boolean;
//   role: string;
//   clinic_id: number;
//   created_at: string;
//   two_fa_preference?: string;
// }

// const PatientModal: React.FC<PatientModalProps> = ({
//   open,
//   setOpen,
//   clinicProducts,
//   clinicId,
//   patient,
// }) => {
//   const [products, setProducts] = useState<PatientProduct[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [updating, setUpdating] = useState(false);
//   const [margins, setMargins] = useState<{ [key: number]: number }>({});

//   useEffect(() => {
//     if (open && patient) {
//       fetchPatientProducts();
//     }
//   }, [open, clinicId, patient]);

//   const fetchPatientProducts = async () => {
//     setLoading(true);
//     try {
//       const result = await ApiService.searchClinicPatientsProducts({
//         clinic_id: clinicId,
//         patient_id: patient?.user_id,
//         is_all: 1,
//       });

//       if (result.success && result.data) {
//         setProducts(result.data);

//         // Initialize margins state with existing values
//         const initialMargins: { [key: number]: number } = {};
//         clinicProducts.forEach((clinicProduct) => {
//           const existingProduct = result.data.find(
//             (p: PatientProduct) => p.product_id === clinicProduct.product_id
//           );
//           initialMargins[clinicProduct.product_id] = existingProduct
//             ? existingProduct.margin_amount
//             : 0;
//         });
//         setMargins(initialMargins);
//       }
//     } catch (err) {
//       console.error("Error fetching products:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleMarginChange = (productId: number, value: string) => {
//     const numericValue = parseFloat(value) || 0;
//     setMargins((prev) => ({
//       ...prev,
//       [productId]: numericValue,
//     }));
//   };

//   const handleUpdate = async () => {
//     if (!patient) return;

//     setUpdating(true);
//     try {
//       const productsToUpdate = clinicProducts.map((product) => ({
//         product_id: product.product_id,
//         margin: margins[product.product_id] || 0,
//       }));

//       const payload = {
//         clinic_id: clinicId,
//         user_id: patient.user_id,
//         products: productsToUpdate,
//       };

//       const result = await ApiService.upsertPatientProducts(payload);

//       if (result.success) {
//         // Optionally show success message
//         console.log("Products updated successfully");
//         setOpen(false);
//       }
//     } catch (err) {
//       console.error("Error updating products:", err);
//     } finally {
//       setUpdating(false);
//     }
//   };

//   const handleClose = () => {
//     setOpen(false);
//     // Reset state when closing
//     setProducts([]);
//     setMargins({});
//   };

//   return (
//     <>
//       <Modal
//         backClass="bg-black/7 backdrop-blur-sm"
//         open={open}
//         handleClose={handleClose}
//       >
//         <div className="modal">
//           <h1 className="heading !text-left mb-2">Update Product Margins</h1>

//           {loading ? (
//             <div className="flex justify-center items-center py-8">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//               <span className="ml-3 text-gray-600">Loading products...</span>
//             </div>
//           ) : (
//             <form>
//               {clinicProducts.map((ele, index) => (
//                 <div key={index} style={{ marginBottom: "17px" }}>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     {ele.product_name} - ${ele.price}
//                   </label>
//                   <input
//                     type="number"
//                     name="text"
//                     min={0}
//                     step={10}
//                     value={margins[ele.product_id] || ""}
//                     onChange={(e) =>
//                       handleMarginChange(ele.product_id, e.target.value)
//                     }
//                     className="w-full px-3 py-2 border rounded-md focus:outline-none"
//                     required
//                     disabled={updating}
//                   />
//                   {/* <p className="mt-1 text-xs text-red-600">error</p> */}
//                 </div>
//               ))}
//             </form>
//           )}

//           <div className="footer">
//             <button
//               onClick={handleClose}
//               className="button px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
//               disabled={updating}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleUpdate}
//               disabled={loading || updating || !patient}
//               className="button px-6 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//             >
//               {updating ? (
//                 <>
//                   <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white inline-block mr-2"></div>
//                   Updating...
//                 </>
//               ) : (
//                 "Update"
//               )}
//             </button>
//           </div>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default PatientModal;
import React, { useEffect, useState } from "react";

import "./popup.css";
import Modal from "../../../../components/modal";
import ApiService from "../../../../services/api";

interface PatientModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  clinicProducts: Product[];
  clinicId: number;
  patient?: Patient | null;
}

interface Product {
  product_id: number;
  product_name?: string;
  margin: number;
  price: number;
}

interface PatientProduct {
  patient_product_price_id: number;
  product_id: number;
  clinic_id: number;
  margin_amount: number;
  is_active: boolean;
}

interface Patient {
  user_id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone_number?: string;
  dob: string;
  status: "pending" | "approved" | "rejected";
  is_active: boolean;
  role: string;
  clinic_id: number;
  created_at: string;
  two_fa_preference?: string;
}

const PatientModal: React.FC<PatientModalProps> = ({
  open,
  setOpen,
  clinicProducts,
  clinicId,
  patient,
}) => {
  const [products, setProducts] = useState<PatientProduct[]>([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [margins, setMargins] = useState<{ [key: number]: number }>({});
  const [activeStates, setActiveStates] = useState<{ [key: number]: boolean }>(
    {}
  );

  useEffect(() => {
    if (open && patient) {
      fetchPatientProducts();
    }
  }, [open, clinicId, patient]);

  const fetchPatientProducts = async () => {
    setLoading(true);
    try {
      const result = await ApiService.searchClinicPatientsProducts({
        clinic_id: clinicId,
        patient_id: patient?.user_id,
        is_all: 1,
      });

      if (result.success && result.data) {
        setProducts(result.data);

        // Initialize margins and active states with existing values
        const initialMargins: { [key: number]: number } = {};
        const initialActiveStates: { [key: number]: boolean } = {};

        clinicProducts.forEach((clinicProduct) => {
          const existingProduct = result.data.find(
            (p: PatientProduct) => p.product_id === clinicProduct.product_id
          );
          initialMargins[clinicProduct.product_id] = existingProduct
            ? existingProduct.margin_amount
            : 0;
          initialActiveStates[clinicProduct.product_id] = existingProduct
            ? existingProduct.is_active
            : true;
        });

        setMargins(initialMargins);
        setActiveStates(initialActiveStates);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleMarginChange = (productId: number, value: string) => {
    const numericValue = parseFloat(value) || 0;
    setMargins((prev) => ({
      ...prev,
      [productId]: numericValue,
    }));
  };

  const handleToggleActive = (productId: number) => {
    setActiveStates((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  const handleUpdate = async () => {
    if (!patient) return;

    setUpdating(true);
    try {
      const productsToUpdate = clinicProducts.map((product) => ({
        product_id: product.product_id,
        margin: margins[product.product_id] || 0,
        is_active: activeStates[product.product_id] ?? true,
      }));

      const payload = {
        clinic_id: clinicId,
        user_id: patient.user_id,
        products: productsToUpdate,
      };

      const result = await ApiService.upsertPatientProducts(payload);

      if (result.success) {
        // Optionally show success message
        console.log("Products updated successfully");
        setOpen(false);
      }
    } catch (err) {
      console.error("Error updating products:", err);
    } finally {
      setUpdating(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    // Reset state when closing
    setProducts([]);
    setMargins({});
    setActiveStates({});
  };

  return (
    <>
      <Modal
        backClass="bg-black/7 backdrop-blur-sm"
        open={open}
        handleClose={handleClose}
      >
        <div className="modal">
          <h1 className="heading !text-left mb-4">Edit Product Margins</h1>

          {loading ? (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <span className="ml-3 text-gray-600">Loading products...</span>
            </div>
          ) : (
            <div className="table-container">
              <div className="table-wrapper">
                <table className="products-table">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Margin</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clinicProducts.map((product) => (
                      <tr key={product.product_id}>
                        <td>
                          <div className="product-name">
                            {product.product_name}
                          </div>
                        </td>
                        <td>
                          <div className="product-price">${product.price}</div>
                        </td>
                        <td>
                          <input
                            type="number"
                            min={0}
                            step={10}
                            value={margins[product.product_id] || ""}
                            onChange={(e) =>
                              handleMarginChange(
                                product.product_id,
                                e.target.value
                              )
                            }
                            className="margin-input"
                            disabled={updating}
                            placeholder="0"
                          />
                        </td>
                        <td>
                          <label className="toggle-switch">
                            <input
                              type="checkbox"
                              checked={activeStates[product.product_id] ?? true}
                              onChange={() =>
                                handleToggleActive(product.product_id)
                              }
                              disabled={updating}
                            />
                            <span className="toggle-slider"></span>
                          </label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="footer">
            <button
              onClick={handleClose}
              className="button px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              disabled={updating}
            >
              Cancel
            </button>
            <button
              onClick={handleUpdate}
              disabled={loading || updating || !patient}
              className="button px-6 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {updating ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white inline-block mr-2"></div>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PatientModal;
